import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-profile-tile',
  templateUrl: './app-tile.component.html'
})
export class AppTileComponent implements OnInit {

  @Input()
  item: any = {};

  @Output()
  navigateToProfile: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  gotoProfile(item) {
    this.navigateToProfile.emit(item);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/app-tile/app-tile.component.ts